import { View, Text, Image } from "@react-pdf/renderer";
import { useTranslation } from "react-i18next";

const SortingErrorsDistributionBlock = ({
  numberOfAnomaly,
  contaminants,
  numberOfStars,
  chartImageUrl,
}) => {
  const { t } = useTranslation();
  return (
    <View
      style={{
        flexDirection: "row",
        paddingTop: 2,
        paddingBottom: 5,
        paddingHorizontal: 20,
        justifyContent: "space-between",
      }}
    >
      <View style={{ width: "30%" }}>
        <View>
          <Text
            style={{
              fontSize: 18,
              color: "#00A7A6",
              fontFamily: "Mulish",
              fontWeight: 1000,
              letterSpacing: "1px",
            }}
          >
            {t("Distribution of anomalies")}
          </Text>
        </View>
        <View style={{ marginTop: 20 }}>
          <Text
            style={{
              fontSize: 18,
              fontFamily: "Mulish",
              color: "#e81d7a",
              fontWeight: 1000,
            }}
          >
            {numberOfAnomaly}
          </Text>
          <Text
            style={{
              fontSize: 12,
              fontFamily: "Mulish",
            }}
          >
            {numberOfAnomaly > 1 ? t("sorting_errors") : t("sorting_error")}
          </Text>
        </View>
        <View style={{ marginTop: 20 }}>
          <Text
            style={{
              fontSize: 18,
              fontFamily: "Mulish",
              color: "#e81d7a",
              fontWeight: 1000,
            }}
          >
            {contaminants}%
          </Text>
          <Text
            style={{
              fontSize: 12,
              fontFamily: "Mulish",
            }}
          >
            {t("of contaminants")}
          </Text>
        </View>
        <View style={{ marginTop: 20 }}>
          <Image
            source={require(
              `../../../static/assets/${numberOfStars}-stars.png`,
            )}
            style={{ width: "70px", marginLeft: -5 }}
          />
          <Text
            style={{
              fontSize: 12,
              fontFamily: "Mulish",
            }}
          >
            {t("Waste category quality")}
          </Text>
          <Text style={{ fontSize: 7, marginTop: 4 }}>
            (
            {numberOfStars === 0
              ? t("More than 30% of contaminants")
              : numberOfStars === 1
                ? t("Between 15% and 30% of contaminants")
                : numberOfStars === 2
                  ? t("Between 5% and 15% of contaminants")
                  : t("Less than 5% of contaminants")}
            )
          </Text>
        </View>
      </View>
      <View
        style={{
          width: "70%",
          justifyContent: "flex-start",
          marginTop: -5,
        }}
      >
        {chartImageUrl && (
          <Image
            style={{ width: "370px", height: "auto" }}
            src={chartImageUrl}
          />
        )}
      </View>
    </View>
  );
};

export default SortingErrorsDistributionBlock;
